export interface IDynamicOrderBook {
  connection_id: string;
  is_active: boolean;
  mode: string;
  end_sell: string;
  start_sell: string;
  price_step_min_sell: string;
  price_step_max_sell: string;
  count_of_orders_sell: string;
  pause_between_orders_sell: string;
  pause_between_cycles_sell: string;
  end_buy: string;
  start_buy: string;
  price_step_min_buy: string;
  price_step_max_buy: string;
  count_of_orders_buy: string;
  pause_between_orders_buy: string;
  pause_between_cycles_buy: string;
}

export type skipMode = "BUY" | "SELL" | "BOTH";
export type SwapOrderMode = "SELL_BUY" | "BUY_SELL" | "RANDOM";

export interface ISpread {
  connection_id: string;
  is_active: boolean;
  spread_skip_sell_one: string;
  spread_skip_sell_sum: string;
  spread_skip_buy_one: string;
  spread_skip_buy_sum: string;
  spread_skip_mode: skipMode;
  spread_skip_sell_skipped_amount: string;
  spread_skip_buy_skipped_amount: string;
}

export interface IVolumeIncrease {
  connection_id: string;
  volume_increasing_ratio: number;
  cancel_tail_orders: boolean;
  alternative_account_trading_mode: boolean;
}

export interface IMMBots {
  id: string;
  connection_id: string;
  mindif: string;
  dont_trade_price_max: string;
  dont_trade_price_min: string;
  precision_amount: number;
  buy_before_sell_max: string;
  buy_before_sell_min: string;
  trade_type: string;
  min_count_of_orders: number;
  max_count_of_orders: number;
  volume_to_trade_per_day_max: string;
  volume_to_trade_per_day_min: string;
  precision_price: number;
  min_exchange_amount: string;
  dont_check_amount: string;
  is_reverse_on: boolean;
  restart_after_stop: boolean;
  algorithm_mode: AlgorithmMode;
  algorithm_mode_changed_at: string | null;
  gate_batch_enabled?: boolean;
}

export type AlgorithmMode =
  | "legacy"
  | "lifecycle_v2_shadow"
  | "lifecycle_v2_live";

export interface MMSettingsAdminConnection {
  id: string;
  managers: string[];
  hidden: boolean;
  is_active: boolean;
  exchange: string;
  open_key: string;
  private_key: string;
  password: string;
  pair_name: string;
  swap_order_mode?: SwapOrderMode;
}

export interface LiquidBotTrades {
  id: string;
  pair: string;
  price: string;
  amount: string;
  is_buy: string;
}

export interface Currency {
  currency_name: string;
  free: string;
  locked: string;
}

export interface LiquidBotsData {
  id: string;
  open_key: string;
  private_key: string;
  password: string;
  connection_id: string;
  precision_amount: number;
  precision_price: number;
}

export enum TradeType {
  BUY = "BUY",
  SELL = "SELL",
}
export interface CreateNewTrade {
  pair: string;
  price: number;
  amount: number;
  is_buy: TradeType;
}

interface orders {
  id: string;
  connection_id: string;
  pair: string;
  order_side: string;
  price: string;
  amount: string;
  exchange_id: string;
  closed: boolean;
  executed_price?: string | null;
  executed_amount?: string | null;
  exchange_status?: string | null;
  exchange_created_at?: string | null;
  exchange_updated_at?: string | null;
  order_source?: string | null;
  risk_details?: { reason: string; base_delta_before_fees: string | null } | null;
  execution_details?: {
    trade_id: string;
    price: string;
    amount: string;
    role?: string | null;
    fee?: string | null;
    fee_currency?: string | null;
    executed_at?: string | null;
    timestamp_ms?: string | null;
  }[] | null;
  created_at: string;
}
export interface GetBotOrders {
  connection_id: string;
  orders: orders[];
  total_count: number
}

export enum ESwapBalances {
  MM = "MM",
  LIQUID = "LIQUID",
}

export interface LastOrderList {
  pair: string;
  min_price: string;
  max_price: string;
  min_step_price: string;
  max_step_price: string;
  min_amount: string;
  max_amount: string;
  is_buy: TradeType;
}
